import { Validator } from "vee-validate";

const commaSeparated = async (value, { type } = {}) => {
  const v = new Validator();
  const values = value.split(',').map(a => a.trim());
  value = values.join(',');
  const all = await Promise.all(values.map(single => {
    return new Promise(async (resolve, reject) => {
      if (!single) resolve(false);
      const { valid, errors } = await v.verify(single, type);
      resolve(valid);
    });
  }));
  return all.every(a => a === true);
};

Validator.extend('commaSeparated', commaSeparated, {
  paramNames: ['type']
});




// WEBPACK FOOTER //
// ./src/Validation.js